"use client";

import { c as _c } from "react/compiler-runtime";
import { Grid2X2Icon, LayoutPanelTopIcon, SpaceIcon, SquareIcon } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { debounce } from "@/ui/hooks/use-debounced-value";
import { Label } from "@/ui/shadcn/label";
import { Switch } from "@/ui/shadcn/switch";
import { StatefulColorPicker } from "@/ui/stateful-color-picker";
import { BuilderTabField } from "@/ui/yns-components/builder-tab-field";
import { YnsLink } from "@/ui/yns-link";
import { ASPECT_RATIO_OPTIONS } from "../../shared/form-options";
import { ProductRelatedSelect } from "./product-related-select";
export const ProductDetailsForm = t0 => {
  const $ = _c(85);
  const {
    data,
    theme,
    props
  } = t0;
  const context = useStoreBuilderContext();
  if (!props) {
    return null;
  }
  const t1 = `/admin/products/${props.slug}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <p className="leading-snug text-sm text-neutral-600 mb-4">Edit all product details on a dedicated page:{" "}<YnsLink href={t1} className="underline">Edit product</YnsLink></p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["layout"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AccordionTrigger className="px-4 py-3 bg-neutral-100/80 hover:bg-neutral-100 font-medium text-left rounded-xs data-[state=open]:rounded-b-none">{"Layout & Display"}</AccordionTrigger>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = data.imageLayout ?? "main";
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      value: "main",
      label: "Main",
      icon: <LayoutPanelTopIcon className="w-4 h-4" />
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      value: "grid",
      label: "Grid",
      icon: <Grid2X2Icon className="w-4 h-4" />
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [t6, t7, {
      value: "carousel",
      label: "Carousel",
      icon: <SquareIcon className="w-4 h-4" />
    }];
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t5) {
    t9 = <BuilderTabField fieldPath="imageLayout" defaultValue={t5} label="Image Layout" options={t8} />;
    $[7] = t5;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = data.aspectRatio ?? "1/1";
  let t11;
  if ($[9] !== t10) {
    t11 = <BuilderTabField fieldPath="aspectRatio" defaultValue={t10} label="Aspect Ratio" options={ASPECT_RATIO_OPTIONS} />;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const t12 = data.columnGap ?? "sm";
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      value: "sm",
      label: "Small",
      icon: <SpaceIcon className="size-4 scale-x-75" />
    };
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      value: "md",
      label: "Medium",
      icon: <SpaceIcon className="size-4" />
    };
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [t13, t14, {
      value: "lg",
      label: "Large",
      icon: <SpaceIcon className="size-4 scale-x-125" />
    }];
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== t12) {
    t16 = <BuilderTabField fieldPath="columnGap" defaultValue={t12} label="Gap between columns" options={t15} />;
    $[14] = t12;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  const t17 = data.showStickyBar ?? true;
  let t18;
  if ($[16] !== context) {
    t18 = debounce(value => {
      context.saveSelectedPageSectionField({
        fieldPath: "showStickyBar",
        value
      });
    }, 300, {
      leading: true,
      trailing: true
    });
    $[16] = context;
    $[17] = t18;
  } else {
    t18 = $[17];
  }
  let t19;
  if ($[18] !== t17 || $[19] !== t18) {
    t19 = <Switch required={true} defaultChecked={t17} onCheckedChange={t18} />;
    $[18] = t17;
    $[19] = t18;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span>Show sticky bar</span>;
    $[21] = t20;
  } else {
    t20 = $[21];
  }
  let t21;
  if ($[22] !== t19) {
    t21 = <Label className="flex items-center gap-2">{t19}{t20}</Label>;
    $[22] = t19;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="text-[0.8rem] mt-1 text-muted-foreground">The bar will be visible when the "Add to cart" button is not currently visible (i.e., when users scroll down)</p>;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] !== t21) {
    t23 = <div>{t21}{t22}</div>;
    $[25] = t21;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t11 || $[28] !== t16 || $[29] !== t23 || $[30] !== t9) {
    t24 = <AccordionItem value="layout" className="border rounded-xs bg-neutral-50/50 data-[state=open]:bg-white">{t4}<AccordionContent className="px-4 py-4"><div className="space-y-4">{t9}{t11}{t16}{t23}</div></AccordionContent></AccordionItem>;
    $[27] = t11;
    $[28] = t16;
    $[29] = t23;
    $[30] = t9;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <AccordionTrigger className="px-4 py-3 bg-neutral-100/80 hover:bg-neutral-100 font-medium text-left rounded-xs data-[state=open]:rounded-b-none">{"Styling & Colors"}</AccordionTrigger>;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <span>Font Color</span>;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  const t27 = theme?.color;
  let t28;
  if ($[34] !== context) {
    t28 = debounce(value_0 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "color",
        value: value_0
      });
    }, 300, {
      trailing: true
    });
    $[34] = context;
    $[35] = t28;
  } else {
    t28 = $[35];
  }
  let t29;
  if ($[36] !== t27 || $[37] !== t28) {
    t29 = <Label className="grid gap-2 w-max">{t26}<StatefulColorPicker defaultValue={t27} onValueChange={t28} /></Label>;
    $[36] = t27;
    $[37] = t28;
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  let t30;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <span>Price Color</span>;
    $[39] = t30;
  } else {
    t30 = $[39];
  }
  const t31 = theme?.priceColor;
  let t32;
  if ($[40] !== context) {
    t32 = debounce(value_1 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "priceColor",
        value: value_1
      });
    }, 300, {
      trailing: true
    });
    $[40] = context;
    $[41] = t32;
  } else {
    t32 = $[41];
  }
  let t33;
  if ($[42] !== t31 || $[43] !== t32) {
    t33 = <Label className="grid gap-2 w-max">{t30}<StatefulColorPicker defaultValue={t31} onValueChange={t32} /></Label>;
    $[42] = t31;
    $[43] = t32;
    $[44] = t33;
  } else {
    t33 = $[44];
  }
  let t34;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <span>Button Background Color</span>;
    $[45] = t34;
  } else {
    t34 = $[45];
  }
  const t35 = theme?.buttonBackgroundColor;
  let t36;
  if ($[46] !== context) {
    t36 = debounce(value_2 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "buttonBackgroundColor",
        value: value_2
      });
    }, 300, {
      trailing: true
    });
    $[46] = context;
    $[47] = t36;
  } else {
    t36 = $[47];
  }
  let t37;
  if ($[48] !== t35 || $[49] !== t36) {
    t37 = <Label className="grid gap-2 w-max">{t34}<StatefulColorPicker defaultValue={t35} onValueChange={t36} /></Label>;
    $[48] = t35;
    $[49] = t36;
    $[50] = t37;
  } else {
    t37 = $[50];
  }
  let t38;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <span>Button Text Color</span>;
    $[51] = t38;
  } else {
    t38 = $[51];
  }
  const t39 = theme?.buttonTextColor;
  let t40;
  if ($[52] !== context) {
    t40 = debounce(value_3 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "buttonTextColor",
        value: value_3
      });
    }, 300, {
      trailing: true
    });
    $[52] = context;
    $[53] = t40;
  } else {
    t40 = $[53];
  }
  let t41;
  if ($[54] !== t39 || $[55] !== t40) {
    t41 = <Label className="grid gap-2 w-max">{t38}<StatefulColorPicker defaultValue={t39} onValueChange={t40} /></Label>;
    $[54] = t39;
    $[55] = t40;
    $[56] = t41;
  } else {
    t41 = $[56];
  }
  let t42;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <span>Button Background Color when mouse is over</span>;
    $[57] = t42;
  } else {
    t42 = $[57];
  }
  const t43 = theme?.buttonHoverBackgroundColor;
  let t44;
  if ($[58] !== context) {
    t44 = debounce(value_4 => {
      context.saveSelectedPageSectionThemeField({
        fieldPath: "buttonHoverBackgroundColor",
        value: value_4
      });
    }, 300, {
      trailing: true
    });
    $[58] = context;
    $[59] = t44;
  } else {
    t44 = $[59];
  }
  let t45;
  if ($[60] !== t43 || $[61] !== t44) {
    t45 = <Label className="grid gap-2 w-max">{t42}<StatefulColorPicker defaultValue={t43} onValueChange={t44} /></Label>;
    $[60] = t43;
    $[61] = t44;
    $[62] = t45;
  } else {
    t45 = $[62];
  }
  let t46;
  if ($[63] !== t29 || $[64] !== t33 || $[65] !== t37 || $[66] !== t41 || $[67] !== t45) {
    t46 = <AccordionItem value="styling" className="border rounded-xs bg-neutral-50/50 data-[state=open]:bg-white">{t25}<AccordionContent className="px-4 pb-4"><div className="space-y-4">{t29}{t33}{t37}{t41}{t45}</div></AccordionContent></AccordionItem>;
    $[63] = t29;
    $[64] = t33;
    $[65] = t37;
    $[66] = t41;
    $[67] = t45;
    $[68] = t46;
  } else {
    t46 = $[68];
  }
  let t47;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <AccordionTrigger className="px-4 py-3 bg-neutral-100/80 hover:bg-neutral-100 font-medium text-left rounded-xs data-[state=open]:rounded-b-none">Product Upsell</AccordionTrigger>;
    $[69] = t47;
  } else {
    t47 = $[69];
  }
  let t48;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <h4 className="font-medium mb-3">Related Products</h4>;
    $[70] = t48;
  } else {
    t48 = $[70];
  }
  const t49 = data.relatedProducts?.[0] || "";
  let t50;
  if ($[71] !== t49) {
    t50 = <ProductRelatedSelect selectedProduct={t49} position={0} />;
    $[71] = t49;
    $[72] = t50;
  } else {
    t50 = $[72];
  }
  const t51 = data.relatedProducts?.[1] || "";
  let t52;
  if ($[73] !== t51) {
    t52 = <ProductRelatedSelect selectedProduct={t51} position={1} />;
    $[73] = t51;
    $[74] = t52;
  } else {
    t52 = $[74];
  }
  let t53;
  if ($[75] !== t50 || $[76] !== t52) {
    t53 = <AccordionItem value="upsell" className="border rounded-xs bg-neutral-50/50 data-[state=open]:bg-white">{t47}<AccordionContent className="px-4 pb-4"><div className="space-y-4"><div>{t48}<div className="flex flex-col space-y-4">{t50}{t52}</div></div></div></AccordionContent></AccordionItem>;
    $[75] = t50;
    $[76] = t52;
    $[77] = t53;
  } else {
    t53 = $[77];
  }
  let t54;
  if ($[78] !== t24 || $[79] !== t46 || $[80] !== t53) {
    t54 = <Accordion type="multiple" defaultValue={t3} className="w-full space-y-3">{t24}{t46}{t53}</Accordion>;
    $[78] = t24;
    $[79] = t46;
    $[80] = t53;
    $[81] = t54;
  } else {
    t54 = $[81];
  }
  let t55;
  if ($[82] !== t2 || $[83] !== t54) {
    t55 = <div className="relative">{t2}{t54}</div>;
    $[82] = t2;
    $[83] = t54;
    $[84] = t55;
  } else {
    t55 = $[84];
  }
  return t55;
};